import { ParamsService } from '../services'

const updateCategoriaDelito = (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await ParamsService.updateCategoriaDelito(params)
      resolve(response)
    } catch (error) {
      reject({ error: true, message: error.message })
    }
  })
}

export default updateCategoriaDelito 